<a href="{{ url }}" target="_blank">
    <button mat-button>
        <img class="email-button-icon" src="{{ imagePath }}.png" width="{{width}}" height="{{height}}" alt="Proveedor de servicio email" />
        {{ text }}
    </button>
</a>
